// import React from 'react';
// import '../style.css';

// const Footer = () => {
//   return (
//     <footer className="footer">
//       <div className="footer-container">
        
//         {/* Logo with Social Icons */}
//         <div className="footer-column logo-column">
//           <div className="logo-container">
//             <img 
//               src="/logo.png" 
//               alt="Shree Balaji Travels" 
//               className="footer-logo"
//               onError={(e) => {
//                 e.target.onerror = null;
//                 e.target.src = "https://via.placeholder.com/120x40/4a342e/ffd700?text=Balaji+Travels";
//               }}
//             />
//           </div>
          
//           <div className="social-section">
//             <p className="social-title">Connect With Us</p>
//             <div className="social-icons">
//               {/* Facebook */}
//               <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon facebook">
//                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#1877F2">
//                   <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
//                 </svg>
//               </a>
              
//               {/* Twitter */}
//               <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon twitter">
//                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#1DA1F2">
//                   <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.213c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
//                 </svg>
//               </a>
              
//               {/* Instagram */}
//               <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
//                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="url(#instagram-gradient)">
//                   <defs>
//                     <linearGradient id="instagram-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
//                       <stop offset="0%" stopColor="#F58529" />
//                       <stop offset="25%" stopColor="#DD2A7B" />
//                       <stop offset="50%" stopColor="#8134AF" />
//                       <stop offset="75%" stopColor="#515BD4" />
//                       <stop offset="100%" stopColor="#F58529" />
//                     </linearGradient>
//                   </defs>
//                   <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
//                 </svg>
//               </a>
              
//               {/* YouTube */}
//               <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-icon youtube">
//                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#FF0000">
//                   <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
//                 </svg>
//               </a>
//             </div>
//           </div>
//         </div>
        
//         {/* About Column */}
//         <div className="footer-column about-column">
//           <h4 className="column-title">About</h4>
//           <div className="footer-links">
//             <a href="#" className="footer-link">About Us</a>
//             <a href="#" className="footer-link">Tour Package</a>
//             <a href="#" className="footer-link">Air Ticket</a>
//             <a href="#" className="footer-link">Contact Us</a>
//             <a href="#" className="footer-link">Cab Service</a>
//             <a href="#" className="footer-link">Policy And Policy</a>
//           </div>
//         </div>
        
//         {/* Quick Links Column */}
//         <div className="footer-column quicklinks-column">
//           <h4 className="column-title">Quick Links</h4>
//           <div className="footer-links">
//             <a href="#" className="footer-link">Home</a>
//             <a href="#" className="footer-link">Hotel Booking</a>
//             <a href="#" className="footer-link">Cab Service</a>
//             <a href="#" className="footer-link">Pind Daan</a>
//             <a href="#" className="footer-link">Book Cruise</a>
//             <a href="#" className="footer-link">Contact</a>
//           </div>
//         </div>
        
//         {/* Reach US Column */}
//         <div className="footer-column contact-column">
//           <h4 className="column-title">Reach US</h4>
//           <div className="contact-info">
//             <div className="contact-item">
//               <div className="contact-icon-box">
//                 <i className="fas fa-phone-alt"></i>
//               </div>
//               <div className="contact-details">
//                 <span className="contact-label">Phone</span>
//                 <a href="tel:+919415799879" className="contact-value">+91 9415799879</a>
//               </div>
//             </div>
            
//             <div className="contact-item">
//               <div className="contact-icon-box">
//                 <i className="fas fa-envelope"></i>
//               </div>
//               <div className="contact-details">
//                 <span className="contact-label">Email</span>
//                 <a href="mailto:info@shreebalajitravel.com" className="contact-value">info@shreebalajitravel.com</a>
//               </div>
//             </div>
//           </div>
//         </div>
        
//       </div>
      
//       {/* Footer Bottom */}
//       <div className="footer-bottom">
//         <div className="footer-bottom-container">
//           <p className="copyright">&copy; {new Date().getFullYear()} Shree Balaji Travel. All Rights Reserved.</p>
//           <div className="policy-links">
//             <a href="#">Privacy Policy</a>
//             <span className="divider">|</span>
//             <a href="#">Terms of Service</a>
//             <span className="divider">|</span>
//             <a href="#">Disclaimer</a>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;



import React from 'react';
import { Link } from 'react-router-dom';
import '../style.css';
import { 
  FaFacebookF, 
  FaTwitter, 
  FaInstagram, 
  FaYoutube,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp
} from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // Function to handle policy link clicks
  const handlePolicyClick = (policyType) => {

    window.location.href = `/policy#${policyType}`;
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Logo with Social Icons */}
        <div className="footer-column logo-column">
          <div className="logo-container">
            <img 
              src="/logo.png" 
              alt="Shree Balaji Travels" 
              className="footer-logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://via.placeholder.com/120x40/4a342e/ffd700?text=Balaji+Travels";
              }}
            />
          </div>
          
          <p className="footer-description">
            Your trusted travel partner in Varanasi. Premium taxi services, tour packages, 
            and travel solutions since 2010.
          </p>
          
          <div className="social-section">
            <p className="social-title">Connect With Us</p>
            <div className="social-icons">
              {/* Facebook */}
              <a 
                href="https://facebook.com/shreebalajitravelsvaranasi" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon facebook"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
              
              {/* Twitter */}
              <a 
                href="https://twitter.com/balajitravels" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon twitter"
                aria-label="Twitter"
              >
                <FaTwitter />
              </a>
              
              {/* Instagram */}
              <a 
                href="https://instagram.com/shreebalajitravels_varanasi" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon instagram"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              
              {/* YouTube */}
              <a 
                href="https://youtube.com/c/ShreeBalajiTravels" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon youtube"
                aria-label="YouTube"
              >
                <FaYoutube />
              </a>

              {/* WhatsApp */}
              <a 
                href="https://wa.me/919415799879" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon whatsapp"
                aria-label="WhatsApp"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>
        </div>
        
        {/* About Column */}
        <div className="footer-column about-column">
          <h4 className="column-title">About</h4>
          <div className="footer-links">
            <Link to="/about" className="footer-link">About Us</Link>
            <Link to="/tour-packagesection" className="footer-link">Tour Packages</Link>
            <Link to="/texi-services" className="footer-link">Air Tickets</Link>
            <Link to="/contact" className="footer-link">Contact Us</Link>
            <Link to="/texi-services" className="footer-link">Cab Service</Link>
            <Link to="/policy-page" className="footer-link">Policies</Link>
          </div>
        </div>
        
        {/* Quick Links Column */}
        <div className="footer-column quicklinks-column">
          <h4 className="column-title">Quick Links</h4>
          <div className="footer-links">
            <Link to="/" className="footer-link">Home</Link>
            <Link to="/hotel-booking" className="footer-link">Hotel Booking</Link>
            <Link to="/texi-services" className="footer-link">Cab Service</Link>
            <Link to="/pind-daan" className="footer-link">Pind Daan</Link>
            <Link to="/book-cruise" className="footer-link">Book Cruise</Link>
            <Link to="/contact" className="footer-link">Contact</Link>
          </div>
        </div>
        
        {/* Reach US Column */}
        <div className="footer-column contact-column">
          <h4 className="column-title">Reach US</h4>
          <div className="contact-info">
            <div className="contact-item">
              <div className="contact-icon-box">
                <FaPhoneAlt />
              </div>
              <div className="contact-details">
                <span className="contact-label">Phone</span>
                <a href="tel:+919415799879" className="contact-value">+91 9415799879</a>
              </div>
            </div>
            
            <div className="contact-item">
              <div className="contact-icon-box">
                <FaEnvelope />
              </div>
              <div className="contact-details">
                <span className="contact-label">Email</span>
                <a href="mailto:info@shreebalajitravel.com" className="contact-value">info@shreebalajitravel.com</a>
                <a href="mailto:booking@shreebalajitravel.com" className="contact-value">booking@shreebalajitravel.com</a>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon-box">
                <FaMapMarkerAlt />
              </div>
              <div className="contact-details">
                <span className="contact-label">Address</span>
                <span className="contact-value address">D.58/12-A, Plot No 84, Gandhi Nagar, Sigra, Varanasi, Uttar Pradesh 221002</span>
              </div>
            </div>
          </div>
        </div>
        
      </div>
      
      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p className="copyright">
            &copy; {currentYear} Shree Balaji Travel. All Rights Reserved.
          </p>
          <div className="policy-links">
            {/* Option 1: Using React Router Link */}
            <Link 
              to="/policy-page" 
              state={{ scrollTo: 'privacy' }}
              className="policy-link"
            >
              Privacy Policy
            </Link>
            <span className="divider">|</span>
            
            <Link 
              to="/terms-service" 
              state={{ scrollTo: 'terms' }}
              className="policy-link"
            >
              Terms of Service
            </Link>
            <span className="divider">|</span>
            
            <Link 
              to="/cancellation-policy" 
              state={{ scrollTo: 'cancellation' }}
              className="policy-link"
            >
              Cancellation Policy
            </Link>

          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;